export const UserSanctionReasons = [
  {
    reason: "욕설/비방 표현",
    key: "abuse",
  },
  {
    reason: "음란물/외설적 내용",
    key: "pornography",
  },
  {
    reason: "스팸/홍보/도배",
    key: "spam",
  },
  {
    reason: "부적절한 서비스 이용",
    key: "improper",
  },
  {
    reason: "개인정보 노출 유도",
    key: "privacy",
  },
  {
    reason: "허위 사실 유포/타인 사칭",
    key: "false_information",
  },
  {
    reason: "저작권 침해",
    key: "copyright",
  },
  {
    reason: "불건전한 프로필",
    key: "unhealthy_profile",
  },
  {
    reason: "신고 누적 자동 제재",
    key: "accumulation_report",
  },
];
